// #BACE60 -> #2B96D8
export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#B08937',
    light: '#FBF9F4',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#B08937',
    contrastText: '#0A5285',
    light: '#D9EDF7',
  },
  text: {
    primary: '#363635',
    secondary: '#273645',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  border: '#D1D5DB',
  background: {
    main: '#F4F4F4',
    paper: '#FFF',
    default: '#FFF',
    header: 'rgba(17, 183, 205, 0.8)',
    footer: 'rgba(238, 236, 233, 0.6)',
    level2: '#f7f8fb',
    level1: '#FFF',
    steps: '#B08937',
    tableHead: '#B08937',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#FBF9F4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#262626',
    secondary: 'rgb(240,243,243)',
    light: 'rgba(242, 242, 242, 0.8)',
    secondaryLight: '#FBF7F5',
    cardBorder: '#374151',
  },
  verticalBar: {
    used: '#B08937',
    unused: 'rgba(242, 222, 157, 0.6)',
    unlimited: '#C0C0C0',
  },
};
